import React from "react";

import type { Venue } from "../types";
import type { VenueFormState } from "../utils/venueAddress";
import { AddressFields } from "./AddressFields";

type Props = {
  form: VenueFormState;
  onChange: (patch: Partial<VenueFormState>) => void;
  idPrefix?: string;
  venues?: Venue[];
  districtOrphanValue?: string | null;
};

export const VenueAddressFields: React.FC<Props> = ({
  form,
  onChange,
  idPrefix = "venue",
  venues = [],
  districtOrphanValue,
}) => (
  <AddressFields
    form={form}
    onChange={onChange}
    idPrefix={idPrefix}
    variant="venue"
    venues={venues}
    districtOrphanValue={districtOrphanValue}
  />
);
